import { render, staticRenderFns } from "./ChineseSyllable.vue?vue&type=template&id=243897f0"
import script from "./ChineseSyllable.vue?vue&type=script&lang=js"
export * from "./ChineseSyllable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports